var App = App || {};

App.MovingImages = (function ($) {
    'use strict';

    function Init(selector) {
        if (selector.length && selector.find(".splide").length) {
            const carousels = selector.find(".splide");
            if (carousels.length) {
                carousels.each(function () {
                    var carousel = $(this);

                    const splideCarousel = new Splide(carousel[0], {
                        pagination: false,
                        type: 'loop',
                        focus: "center",
                        fixedWidth: "546px",
                        gap: "72px",
                        speed: 1000,
                        drag: true,
                        snap: false,
                        perMove: 1,
                        breakpoints: {
                            991: {
                                fixedWidth: "283px",
                                gap: "20px",
                            }
                        }
                    });

                    splideCarousel.mount();

                    adjustTabindexes(carousel);

                    const currPageIndicator = selector.find(".carousel-navigation .curr-page")
                    const pageCountIndicator = selector.find(".carousel-navigation .page-count")
                    pageCountIndicator.text(splideCarousel.length);

                    const nextBtn = selector.find(".slider-nav.carousel-next");
                    const prevBtn = selector.find(".slider-nav.carousel-prev");

                    nextBtn.on("click", function () {
                        splideCarousel.go('+1')
                    });

                    prevBtn.on("click", function () {
                        splideCarousel.go('-1')
                    });

                    splideCarousel.on('click', function (slideComponent) {
                        if (!$(slideComponent.slide).hasClass("is-active")) {
                            splideCarousel.go(slideComponent.index)
                        }
                    });

                    splideCarousel.on('move', function (newIndex) {
                        carousel.find(".splide__slide.appear").removeClass("appear");
                        var newActiveSlide = splideCarousel.Components.Slides.getAt(newIndex).slide;
                        $(newActiveSlide).addClass("appear");
                        currPageIndicator.text(newIndex + 1);

                        adjustTabindexes(carousel);
                    });
                });
            }
        }
    }

    function adjustTabindexes(carousel) {
        carousel.find(".splide__slide.is-active.is-visible a").attr("tabindex", "0");
        carousel.find(".splide__slide:not(.is-active.is-visible)").attr("tabindex", "-1");
        carousel.find(".splide__slide:not(.is-active.is-visible) a").attr("tabindex", "-1");
    }

    return {
        Init: Init
    };

})(jQuery);